export class FilterBase {
    hidden!: boolean;
}